'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _login = require('./login');

var _siteNav = require('./site-nav');

var _siteHeader = require('./site-header');

var _siteFooter = require('./site-footer');

var _buyerBaseSelect = require('./components/buyer-base-select');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.layout', ['ng']).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider.state('login', {
        parent: 'master',
        url: '/login',
        views: {
            'main@root': {
                component: 'login'
            },
            'header@root': '',
            'aside@root': '',
            'menu@root': '',
            'submenu@root': '',
            'footer@root': ''
        },
        data: {
            noTenant: true
        },
        resolve: {
            tenants: ["$injector", function tenants($injector) {
                var tenantService = $injector.get('tenantService');
                var authService = $injector.get('authService');
                if (!authService.hasClaim('ShopAdmin')) {
                    return tenantService.getAll().then(function (tenants) {
                        authService.customUserInfo = Object.assign(authService.customUserInfo || {}, {
                            tenants: tenants
                        });
                        return tenants;
                    });
                }
            }],
            isAdmin: ["$injector", function isAdmin($injector) {
                var authService = $injector.get('authService');
                return authService.hasClaim('ShopAdmin');
            }],
            isSeller: ["$injector", function isSeller($injector) {
                var authService = $injector.get('authService');
                return authService.isSeller;
            }],
            isBuyer: ["$injector", function isBuyer($injector) {
                var authService = $injector.get('authService');
                return authService.isBuyer;
            }],
            redirectLocation: ["$stateParams", function redirectLocation($stateParams) {
                return $stateParams.redirectLocation || '/';
            }],
            selectedSauk: ["$stateParams", function selectedSauk($stateParams) {
                return $stateParams.selectedSauk;
            }]
        },
        params: {
            redirectLocation: { value: '/', squash: true },
            selectedSauk: { value: null, squash: true }
        }
    });
}]).component('login', _login.loginComponent).component('siteNav', _siteNav.siteNavComponent).component('siteHeader', _siteHeader.siteHeaderComponent).component('siteFooter', _siteFooter.siteFooterComponent).component('buyerBaseSelect', _buyerBaseSelect.buyerBaseSelectComponent);

exports.default = _module.name;


//////////////////
// WEBPACK FOOTER
// ./features/layout/index.js
// module id = 939
// module chunks = 0